/**
 * Browser activity commands stay closed until the separately reviewed release
 * flag is enabled in both the UI build and the database.
 */
export const OUTREACH_ACTIVITY_COMMANDS_ENABLED = false;
export const CANONICAL_REVIEW_COMMANDS_ENABLED = false;
export const LEAD_CONVERSION_COMMANDS_ENABLED = false;
export const OUTREACH_ACTIVITY_DISABLED_MESSAGE =
  'Outreach activity commands are disabled until their separate release review is approved.';

export function assertOutreachActivityCommandsEnabled(): void {
  if (!OUTREACH_ACTIVITY_COMMANDS_ENABLED) {
    throw new Error(OUTREACH_ACTIVITY_DISABLED_MESSAGE);
  }
}

export function assertCanonicalReviewCommandsEnabled(): void {
  if (!CANONICAL_REVIEW_COMMANDS_ENABLED) {
    throw new Error(
      'Canonical-contact commands are disabled until their separate release review is approved.',
    );
  }
}

export function assertLeadConversionCommandsEnabled(): void {
  if (!LEAD_CONVERSION_COMMANDS_ENABLED) {
    throw new Error(
      'Lead conversion is disabled until its separate release review is approved.',
    );
  }
}
